import serverVars from 'server-vars';
import { type DALSellerData, type DALUserData } from '../../../exports/UserDataTypes.ts';

const sellerData: DALSellerData | undefined = serverVars.get('sellerData');
const masqueradeSeller: DALSellerData | undefined = serverVars.get('masqueradeSeller');
const userData: DALUserData | undefined = serverVars.get('userData');
const loginDealer: boolean = !!serverVars.get('loginDealer');
const loginInternal: boolean = !!serverVars.get('loginInternal');

export const userServerVars = {
    seller: sellerData,
    masqueradeSeller,
    user: userData,
    userOrSeller: sellerData || masqueradeSeller || userData,
    isDealer: !!sellerData || !!masqueradeSeller,
    loginDealer,
    loginInternal,
};
